import { render, staticRenderFns } from "./RuLanguageNotice.vue?vue&type=template&id=7dfee721&lang=pug&"
import script from "./RuLanguageNotice.vue?vue&type=script&lang=js&"
export * from "./RuLanguageNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports